import { getJobFloorsForJob } from '../admin/admin.api';
import { buildFloorStack } from '../work-implementation/domain/floorStack';
import { jobFloorRowsToFormValues } from '../work-implementation/domain/mappers/jobFloors.mapper';
import {
  workAgeFromProjectType,
  workCategoryFromConstructionWorkType,
} from '../work-implementation/domain/workJobLookups';
import { defaultValues } from '../work-implementation/features/project-form/schema/defaultValues';
import type { ProjectOption } from './siteVisits.api';

/** Offered when the project has no floors saved (or is not a building). */
export const GENERIC_STAGES = ['Excavation', 'Foundation / footing', 'Plinth', 'General'];

/**
 * The project's stages a visit can be booked for, bottom of the building first:
 * "Foundation · C1–C2", "Ground · S1", "Floor 2 · S4"…
 *
 * Built from the saved floors the same way the Work Details panel draws its elevation
 * (see reports/JobStepDialog.tsx): the form defaults, the job's locked types, then the
 * floor rows mapped back onto form values. Provision floors are not built yet and existing
 * floors are not new work, so neither is offered.
 */
export async function loadProjectStages(project: ProjectOption): Promise<string[]> {
  const floors = await getJobFloorsForJob(project.id);
  const values = {
    ...defaultValues,
    workAge: workAgeFromProjectType(project.projectType) ?? '',
    workCategory: workCategoryFromConstructionWorkType(project.constructionWorkType) ?? '',
    buildingType: project.buildingType ?? '',
    ...jobFloorRowsToFormValues(floors as any[]),
  };
  const stages = buildFloorStack(values)
    .filter((band) => band.kind !== 'additional' && !band.isExisting)
    .reverse()
    .map((band) => `${band.name}${band.drawings ? ` · ${band.drawings}` : ''}`);
  const unique = Array.from(new Set(stages));
  return unique.length ? [...unique, 'General'] : GENERIC_STAGES;
}
